import '@fortawesome/fontawesome-free/js/all.min';


// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js